module.exports = __webpack_public_path__ + "img/img_aviodPhoney_06.625e5cc6.jpg";